import { useEffect, useMemo, useState } from 'react';

import { T } from 'react-translator-component';

import { StyledAutoComplete, Wrapper } from './styles';
import { parsedStations, checkIfHasLocation } from './tools';

import { getMarkers } from '../../../hooks/markers';
import { ChargePoint } from '../../../types/responses/ChargePoints';
interface IMapFilter {
  chargePoints: any;
  selectedListChargePoint: ChargePoint;
  setActiveMarker: (marker) => void;
  setSelectedListChargePoint: (station) => void;
}

const MapFilter = ({
  chargePoints,
  setActiveMarker,
  selectedListChargePoint,
  setSelectedListChargePoint,
}: IMapFilter) => {
  const [selected, setSelected] = useState<ChargePoint>();
  const stations: any = parsedStations(chargePoints.chargePointList);

  const options = useMemo(() => {
    if (!stations?.length) {
      return [];
    }
    const result = stations.map((station) => ({
      value: station.chargeBoxId,
      label: station.description || station.chargeBoxId,
    }));

    return result;
  }, [stations]);

  const handleChange = (selectedStationId) => {
    if (!selectedStationId) {
      setSelected(undefined);

      setSelectedListChargePoint(false);
      setActiveMarker(false);
    } else {
      const selectedStation = stations.find(
        (station) => station.chargeBoxId === selectedStationId,
      );
      setSelected(selectedStation);

      setSelectedListChargePoint(selectedStation);
      const marker = getMarkers(chargePoints).find(
        (marker) => marker.pk === selectedStation.chargeBoxPk,
      );
      setActiveMarker(marker);
      checkIfHasLocation(selectedStation);
    }
  };

  useEffect(() => {
    if (
      selectedListChargePoint &&
      selected?.chargeBoxId !== selectedListChargePoint.chargeBoxId
    ) {
      setSelected(selectedListChargePoint);
    }
  }, [selectedListChargePoint, selected?.chargeBoxId]);

  return (
    <Wrapper>
      <StyledAutoComplete
        options={options}
        value={selected?.chargeBoxId}
        onChange={handleChange}
        placeholder={T('Search stations')}
      />
    </Wrapper>
  );
};

export default MapFilter;
